import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from 'components/v2/Buttons/Button/Button';
import { themes } from 'kb-shared';
import { StepDetail, Description, Subheader } from 'screens/MyJourney/details/StepDetail';
import styled from 'styled-components';
import { pageUrl } from 'utilities/pageUrl';

const { queries } = themes;

export const ReviewResultsDetail = () => {
  const navigate = useNavigate();

  return (
    <StepDetail>
      <FlexContainer>
        <div>
          <Subheader>Your results are ready for review</Subheader>
          <Description>
            Let your care team know if you have any further questions before moving forward with
            treatment.
          </Description>
        </div>

        <ButtonStyled label="View your results" onClick={() => navigate(pageUrl.results())} />
      </FlexContainer>
    </StepDetail>
  );
};

const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and ${queries.minLargeDesktop} {
    flex-direction: row;
  }
`;

const ButtonStyled = styled(Button)`
  min-width: fit-content;
  height: fit-content;
  width: fit-content;
`;
